const SHARE_DOCS_PREFIX = "/share/docs/";

/**
 * Sanitizes token-bearing routes before writing them to logs/telemetry payloads.
 *
 * @remarks
 * Docs share viewer routes embed the share token in the pathname. Tokens are bearer credentials
 * and must never be emitted to logs (see `docs/LOGGING.md`).
 */
export const sanitizeAdminRouteForLogging = (
  pathname: string | undefined,
): string | undefined => {
  if (typeof pathname !== "string") {
    return undefined;
  }

  const trimmed = pathname.trim();
  if (!trimmed) {
    return undefined;
  }

  if (trimmed.startsWith(SHARE_DOCS_PREFIX)) {
    const suffix = trimmed.slice(SHARE_DOCS_PREFIX.length);
    const parts = suffix.split("/").filter(Boolean);
    if (parts.length >= 1) {
      return "/share/docs/:token";
    }
  }

  return trimmed;
};
